
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/panel-beaters-near-me",
      function () {
        return require("private-next-pages/panel-beaters-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/panel-beaters-near-me"])
      });
    }
  